<template>
  <div class="step__block">
    <h3 class="step__title">no discount extra</h3>
    <NoDiscountExtraItemsTable
      :extraItems="activeExtraItems"
      :isDiscountable="false"
      v-model:extraTotal="extraStore.extraTotal"
    />

    <div class="step__row">
      <h3>No Discount Extra Total:</h3>

      <span class="step__price" v-if="extraTotal">{{
        extraTotal.getSystemPrice(dealTypeCode).format()
      }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";

import { NoDiscountExtraItemsTable } from "@/modules/extra";
import { useExtraStore } from "@/stores/new/extra.store";
import { useNewEstimateStore } from "@/stores/new/estimateStore";

const estimateStore = useNewEstimateStore();
const estimate = computed(() => estimateStore.estimate);
const dealTypeCode = computed(() => estimate.value.dealTypeCode);

const extraStore = useExtraStore();
const extraTotal = computed(() => extraStore.extraTotal);
const activeExtraItems = computed(() =>
  extraStore.activeExtraItems.filter((item) => !item.discount),
);

const hasActiveExtra = computed(() => extraStore.hasActiveExtra);

onMounted(() => {
  if (!hasActiveExtra.value) {
    extraStore.addExtra();
  }
});
</script>

<style scoped>
.step__block {
  margin-top: 50px;
  padding: 0 0 15px;

  border-bottom: 1px solid #d2d8e3;
}

.step__title {
  color: #404d63;
  font-family: Gilroy;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
}

.step__row h3 {
  color: #404d63;
  font-family: Gilroy;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
}

.step__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.step__price {
  color: #404d63;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
}
</style>
